import customAxios from "./axiosConfig";

const PremiumService = {
    list: function (params) {
        var api_url = window.Urls['popup-list']();
        return customAxios.get(api_url, {params: params});
    },
};

export default PremiumService;